/**
 * 롤권한관리 · 롤별메뉴접근관리 공통 설정 (API 경로, 그리드 정의, 오류 처리)
 */

export const ROLE_API = {
    list: '/commonapi/role/selectRoleList.do',
    detail: '/commonapi/role/selectRoleDetail.do',
    authCodes: '/commonapi/role/selectAuthCodeList.do',
    nextRoleNo: '/commonapi/role/selectNextRoleNo.do',
    insert: '/commonapi/role/insertRole.do',
    update: '/commonapi/role/updateRole.do',
    deleteCheck: '/commonapi/role/selectRoleDeleteCheck.do',
    delete: '/commonapi/role/deleteRole.do',
    menuTree: '/commonapi/role/selectRoleMenuTree.do',
    saveMenuAuth: '/commonapi/role/saveRoleMenuAuth.do',
};

/**
 * 롤 목록 그리드 (롤권한관리·롤별메뉴접근관리 공용).
 * 메뉴권한수는 서버가 미사용 메뉴를 볼 수 있는 개발자 롤(110)에게만 "n (미사용 m)" 으로, 그 밖에는 사용 메뉴 수만 준다
 */
export const roleGridPropsInfo = {
    dataHead: ['NO', '권한코드', '권한명', '롤코드', '롤 명', '사용여부', '기본롤', '사용자수', '메뉴권한수', '등록일'],
    dataColumn: ['SEQ', 'AUTHJOBS', 'AUTHNAME', 'ROLENO', 'ROLENAME', 'USEYN', 'DEFAULTYN', 'USERCNT', 'AUTHCNT_TEXT', 'RES_DT'],
    apiCall: ROLE_API.list,
    apiCntCall: '',
    excelFileName: '',
    excelHead: [],
    colWidth: ['5%', '8%', '15%', '8%', '28%', '7%', '7%', '7%', '8%', '7%'],
};

/** 롤 목록 검색조건 초기값 */
export const roleSearchParamsInit = {
    searchAuthJobs: '',
    searchRoleName: '',
    searchUseYn: '',
    validationCheckList: [],
};

/** 그리드 행 클릭 시 가져올 컬럼 */
export const roleSelectCellParams = ['ROLENO', 'ROLENAME', 'AUTHJOBS', 'AUTHNAME'];

/**
 * API 오류 공통 처리 — 403(메뉴 권한 없음)은 공통 응답 처리(AxiosCORS)가 서버 문구로 안내하므로 넘기고, 그 외는 콘솔 + 안내
 * @param {*} error axios error
 * @param {Function} showNotiModal useModalStore.showNotiModal
 * @param {string} fallbackMessage
 */
export const handleRoleApiError = (error, showNotiModal, fallbackMessage) => {
    const status = error?.response?.status;
    if (status === 403) {
        return;
    }
    console.error(fallbackMessage, error);
    showNotiModal(`${fallbackMessage}\n잠시 후 다시 시도해주세요.`);
};

/** JoinUser.jsx와 같은 기준의 byte 길이 (한글 등 non-ASCII = 2byte, DB KO16MSWIN949 기준) */
export const getByteLength = (text = '') => {
    let byteLength = 0;
    for (let i = 0; i < text.length; i++) {
        byteLength += text.charCodeAt(i) <= 0x007f ? 1 : 2;
    }
    return byteLength;
};

/** 롤 입력값 검증 — 오류 메시지 또는 null (서버 검증과 동일 기준) */
export const validateRoleForm = (form) => {
    if (!form.authjobs) return '권한코드를 선택해주세요.';
    const roleno = Number(form.roleno);
    if (form.roleno === '' || form.roleno === null || !Number.isInteger(roleno) || roleno <= 0 || roleno > 9999999999) {
        return '롤코드는 1 이상의 숫자(최대 10자리)로 입력해주세요.';
    }
    if (!form.rolename || form.rolename.trim() === '') return '롤명을 입력해주세요.';
    if (getByteLength(form.rolename.trim()) > 50) return '롤명은 50byte(한글 25자) 이내로 입력해주세요.';
    if (form.bigo && getByteLength(form.bigo) > 4000) return '비고는 4000byte 이내로 입력해주세요.';
    return null;
};
